import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";

import { InputElement } from "../index";
import Giorni, { checkGiorniConMese } from "./Giorni";

import { dayJS, PLANNING_IN_THE_PAST_AVAILABLE_ROLES } from "../../applicationConf";


const ELEMENTS = ['dataInizio', 'dataFine', 'oraInizio', 'oraFine'];


const BloccoPianificazione = (props) => {
    const corso = useSelector(state => state.corso.corso);
    const ruolo = useSelector(state => state.auth.ruoloScelto);

    const changeValueAndValidity = (newValue, element, id) => {
        const saveElements = {};
        // const check_participants = id === 'dataInizio';

        element.touched = true;
        element.value = newValue;

        if (element.validation.required) {
            if (newValue.trim() !== '') {
                saveElements[id] = validationFieldWithCondition(newValue, element, id);

                if (new RegExp('.*(Inizio|Fine)', 'gi').test(id)) {
                    const start = new RegExp('.*[^Inizo|Fe]', 'i').exec(id)[0];
                    const time = new RegExp('[^' + start + '].*', 'i').exec(id)[0];

                    ELEMENTS.filter(id => new RegExp('^' + start, 'i').test(id))
                        .filter(id => !new RegExp(time + '$', 'i').test(id))
                        .forEach(id => saveElements[id] = validationFieldWithCondition(props[id].value, props[id], id, true));
                }

            } else {
                element.valid = false;
                // element.error = 'Campo Obbligatorio';

                saveElements[id] = element;
            }
        } else {
            saveElements[id] = element;
        }
        props.changeValueBlockPlanning(saveElements, id);
    };

    /**
     * @param {string} id  key for merge element in formState in the parent
     * @param {object} element element with InputElement structure
     * @param {string} value new value of the user
     * @param {boolean} recursiveCheck use for check reciprocally dataInizio-dataFine-oraInizio-OraFine default false
     * */
    const validationFieldWithCondition = (value, element, id, recursiveCheck = false) => {
        let isValid = true;
        switch (id) {
            case 'oraInizio': {
                const { oraFine } = props;
                if (oraFine.value !== '') {
                    if (dayJS(value, 'hh:mm').isBefore(dayJS(oraFine.value, 'hh:mm'), "milliseconds")) {
                        element.valid = isValid;
                        element.error = 'Campo Obbligatorio';
                    } else {
                        element.valid = false;
                        element.error = 'L\'orario di inizio deve essere antecedente all\'orario di fine pianficazione';
                    }
                } else {
                    element.valid = value.trim() !== '' && isValid;
                    element.error = 'Campo Obbligatorio';
                }
                return element;
            }
            case 'oraFine': {
                const { oraInizio } = props;
                if (oraInizio.value !== '') {
                    if (dayJS(value, 'hh:mm').isAfter(dayJS(oraInizio.value, 'hh:mm'), "milliseconds")) {
                        element.valid = isValid;
                        element.error = 'Campo Obbligatorio';
                    } else {
                        element.valid = false;
                        element.error = 'L\'orario di fine deve essere dopo l\'orario di inizio';
                    }

                } else {
                    element.error = 'Campo Obbligatorio';
                }
                return element;
            }
            case 'dataInizio': {
                const { dataFine } = props;

                if (dayJS(value, 'YYYY-MM-DD').isSameOrAfter(corso.dataInizio, 'date')) {
                    if (dataFine.value !== '') {
                        element.valid = dayJS(value, 'YYYY-MM-DD').isSameOrBefore(dataFine.value, 'date') && isValid;
                        element.error = 'La data di inizio deve essere uguale o antecedente la data di fine pianificazione';
                    } else {
                        element.valid = dayJS(value, 'YYYY-MM-DD').isSameOrAfter(corso.dataInizio, 'date') && isValid;
                        element.error = 'Campo Obbligatorio';
                    }

                    if (!recursiveCheck && PLANNING_IN_THE_PAST_AVAILABLE_ROLES.includes(ruolo.toUpperCase())) {
                        if (dayJS(value, 'YYYY-MM-DD').isSameOrAfter(dayJS().format('YYYY-MM-DD'), "date")) {

                            props.motivoForzatura.validation.required = false;
                            changeValueAndValidity('', props.motivoForzatura, props.motivoForzatura.elementConfig.name);
                        } else {
                            props.motivoForzatura.validation.required = true;
                            changeValueAndValidity(props.motivoForzatura.value, props.motivoForzatura, props.motivoForzatura.elementConfig.name);
                        }
                    }
                } else {
                    element.valid = false;
                    element.error = 'La data di inizio pianificazione deve essere uguale o successiva alla data di inizio corso';
                }

                return element;
            }
            case 'dataFine': {
                const { dataInizio, changeValueGiorni } = props;

                if (corso.dataFine) {
                    if (dayJS(value, 'YYYY-MM-DD').isSameOrBefore(corso.dataFine)) {
                        if (dataInizio.value !== '') {
                            element.valid = dayJS(value, 'YYYY-MM-DD').isSameOrAfter(dataInizio.value, 'date') && isValid;
                            element.error = 'La data di fine pianificazione deve essere uguale o successiva alla data di inizio pianificazione';
                        } else {
                            element.valid = dayJS(value, 'YYYY-MM-DD').isSameOrBefore(corso.dataFine) && isValid;
                            element.error = 'La data di fine pianificazione non può essere successiva alla data di fine corso';
                        }

                    } else {
                        element.valid = false;
                        element.error = 'La data di fine pianificazione non può essere successiva alla data di fine corso';
                    }
                } else {
                    element.valid = dayJS(value, 'YYYY-MM-DD').isSameOrAfter(dataInizio.value !== '' ? dataInizio.value : corso.dataInizio, 'date') && isValid;
                    element.error = 'La data di fine pianificazione deve essere uguale o successiva la data di inizio pianificazione';
                }

                if (element.valid) {
                    checkGiorniConMese({
                        giorni: props.giorni,
                        dataInizio: dataInizio.value,
                        dataFine: value,
                        changeValueGiorni
                    });
                }

                return element;
            }
            case 'motivoForzatura': {
                element.valid = element.value != null && element.value !== '';
                return element;
            }
            default:
                return element;
        }
    }

useEffect(() => {
    if (props.type !== 'MP' || props.singleDayMode) {
        return;
    }

    const dataInizioEl = document.querySelector('#dataInizio');
    const dataFineEl = document.querySelector('#dataFine');
    if (dataInizioEl) dataInizioEl.disabled = !props.datesActive;
    if (dataFineEl) dataFineEl.disabled = !props.datesActive;
    ELEMENTS.forEach(id => {
        const element = props[id];
        if (element && element.elementConfig.type === 'date') {
            element.elementConfig.disabled = props.datesActive;
        }
    });
}, [props])

    return (
        <section className='mt-2'>
            <div className='row'>
                {props.singleDayMode ? (
                    <>
                        <InputElement
                            id={'singleDay'}
                            label={'Data'}
                            elementType={'input'}
                            elementConfig={{ type: 'date', name: 'singleDay' }}
                            value={props.singleDayValue.value}
                            invalid={!props.singleDayValue.valid}
                            touched={props.singleDayValue.touched}
                            changedValue={({ target: { value } }) => props.onSingleDayChange(value)}
                            isRequired={true}
                            classes={'col-4 mt-2'}
                            style={props.singleDayValue.style}
                            feedback={props.singleDayValue.error}
                        />
                        {/* Show oraInizio and oraFine even in singleDayMode */}
                        <InputElement
                            key={'oraInizio'}
                            id={'oraInizio'}
                            label={props.oraInizio.label}
                            elementType={props.oraInizio.elementType}
                            elementConfig={props.oraInizio.elementConfig}
                            value={props.oraInizio.value}
                            invalid={!props.oraInizio.valid}
                            touched={props.oraInizio.touched}
                            changedValue={({ target: { value } }) => changeValueAndValidity(value, props.oraInizio, 'oraInizio')}
                            isRequired={props.oraInizio.validation.required}
                            classes={props.oraInizio.cssClass}
                            style={props.oraInizio.style}
                            feedback={props.oraInizio.error}
                        />
                        <InputElement
                            key={'oraFine'}
                            id={'oraFine'}
                            label={props.oraFine.label}
                            elementType={props.oraFine.elementType}
                            elementConfig={props.oraFine.elementConfig}
                            value={props.oraFine.value}
                            invalid={!props.oraFine.valid}
                            touched={props.oraFine.touched}
                            changedValue={({ target: { value } }) => changeValueAndValidity(value, props.oraFine, 'oraFine')}
                            isRequired={props.oraFine.validation.required}
                            classes={props.oraFine.cssClass}
                            style={props.oraFine.style}
                            feedback={props.oraFine.error}
                        />
                    </>
                ) : (
                    ELEMENTS.map(el => (
                        <InputElement key={el}
                            id={el}
                            label={props[el].label}
                            elementType={props[el].elementType}
                            elementConfig={props[el].elementConfig}
                            value={props[el].value}
                            invalid={!props[el].valid}
                            touched={props[el].touched}
                            changedValue={({ target: { value } }) => changeValueAndValidity(value, props[el], el)}
                            isRequired={props[el].validation.required}
                            classes={props[el].cssClass}
                            style={props[el].style}
                            feedback={props[el].error}
                        />
                    ))
                )}
            </div>

            {props.motivoForzatura.validation.required && (
                <div className='row mt-2'>
                    <InputElement key={props.motivoForzatura.elementConfig.name}
                        id={props.motivoForzatura.elementConfig.name}
                        label={props.motivoForzatura.label}
                        elementType={props.motivoForzatura.elementType}
                        elementConfig={props.motivoForzatura.elementConfig}
                        value={props.motivoForzatura.value}
                        invalid={!props.motivoForzatura.valid}
                        touched={props.motivoForzatura.touched}
                        isRequired={props.motivoForzatura.validation.required}
                        changedValue={({ target: { value } }) => changeValueAndValidity(value, props.motivoForzatura, props.motivoForzatura.elementConfig.name)}
                        classes={props.motivoForzatura.cssClass}
                        style={props.motivoForzatura.style}
                        feedback={props.motivoForzatura.error}
                    />
                </div>
            )}

            {!props.singleDayMode && (
                <section className='mt-2'>
                    <div className='row'>
                        <div className='col-12 col-md-12 col-lg-12 col-sm-12'>
                            <Giorni giorni={props.giorni}
                                changeValueGiorni={props.changeValueGiorni}
                                dataFine={props.dataFine.value}
                                action={props.action ? props.action : null}
                                dataInizio={props.dataInizio.value} />
                        </div>
                    </div>
                </section>
            )}
        </section>
    )
};

BloccoPianificazione.propTypes = {
    dataInizio: PropTypes.shape({
        elementType: PropTypes.string,
        elementConfig: PropTypes.shape({
            type: PropTypes.string
        }),
        value: PropTypes.string,
        label: PropTypes.string,
        valid: PropTypes.bool.isRequired,
        touched: PropTypes.bool.isRequired,
        cssClass: PropTypes.string,
        validation: PropTypes.shape({
            required: PropTypes.bool.isRequired
        }),
        error: PropTypes.string
    }).isRequired,
    dataFine: PropTypes.shape({
        elementType: PropTypes.string,
        elementConfig: PropTypes.shape({
            type: PropTypes.string
        }),
        value: PropTypes.string,
        label: PropTypes.string,
        valid: PropTypes.bool.isRequired,
        touched: PropTypes.bool.isRequired,
        cssClass: PropTypes.string,
        validation: PropTypes.shape({
            required: PropTypes.bool.isRequired
        }),
        error: PropTypes.string
    }).isRequired,
    oraInizio: PropTypes.shape({
        elementType: PropTypes.string,
        elementConfig: PropTypes.shape({
            type: PropTypes.string
        }),
        value: PropTypes.string,
        label: PropTypes.string,
        valid: PropTypes.bool.isRequired,
        touched: PropTypes.bool.isRequired,
        cssClass: PropTypes.string,
        validation: PropTypes.shape({
            required: PropTypes.bool.isRequired
        }),
        error: PropTypes.string
    }).isRequired,
    oraFine: PropTypes.shape({
        elementType: PropTypes.string,
        elementConfig: PropTypes.shape({
            type: PropTypes.string
        }),
        value: PropTypes.string,
        label: PropTypes.string,
        valid: PropTypes.bool.isRequired,
        touched: PropTypes.bool.isRequired,
        cssClass: PropTypes.string,
        validation: PropTypes.shape({
            required: PropTypes.bool.isRequired
        }),
        error: PropTypes.string
    }).isRequired,
    giorni: PropTypes.shape({
        giorni: PropTypes.arrayOf(PropTypes.number),
        errori: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
        valid: PropTypes.bool
    }).isRequired,
    changeValueGiorni: PropTypes.func,
    changeValueBlockPlanning: PropTypes.func
};

BloccoPianificazione.defaultProps = {
    dataInizio: {
        elementType: 'input',
        elementConfig: {
            type: 'date'
        },
        value: '',
        label: 'Data inizio serie:',
        valid: true,
        touched: true,
        cssClass: 'col-md-6 col-12 col-sm-12 col-lg-6 mt-2',
        validation: {
            required: false
        },
        error: 'Campo obbligatorio'
    },
    dataFine: {
        elementType: 'input',
        elementConfig: {
            type: 'date'
        },
        value: '',
        label: 'Data fine serie:',
        valid: true,
        touched: true,
        cssClass: 'col-md-6 col-12 col-sm-12 col-lg-6 mt-2',
        validation: {
            required: false
        },
        error: 'Campo obbligatorio'
    },
    oraInizio: {
        elementType: 'input',
        elementConfig: {
            type: 'time'
        },
        value: '',
        label: 'Ora inizio:',
        valid: true,
        touched: true,
        cssClass: 'col-md-6 col-12 col-sm-12 col-lg-6 mt-2',
        validation: {
            required: false
        },
        error: 'Campo obbligatorio'
    },
    oraFine: {
        elementType: 'input',
        elementConfig: {
            type: 'time'
        },
        value: '',
        label: 'Ora fine:',
        valid: true,
        touched: true,
        cssClass: 'col-md-6 col-12 col-sm-12 col-lg-6 mt-2',
        validation: {
            required: false
        },
        error: 'Campo obbligatorio'
    },
    giorni: {
        giorni: [],
        errori: 'Campo Obbligatorio',
        valid: false
    },
    changeValueGiorni: () => {
    },
    changeValueBlockPlanning: () => {
    }
};

export default BloccoPianificazione

